import React from "react";

const CategoryList = React.memo(({ categories, selectedCategory, onCategorySelect }) => {
  return (
    <div className="mt-[60px]">
      <h1 className="font-semibold text-22 text-white">Category</h1>
      <ul className="mt-6">
        <li className="my-1.5">
          <button
            onClick={() => onCategorySelect('')}
            className={`flex items-center gap-3 transition-all duration-300 text-paragraph hover:text-purple w-full text-left ${
              selectedCategory === '' ? 'text-purple' : ''
            }`}
          >
            <svg
              width="6"
              height="13"
              viewBox="0 0 6 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.92285L4.59655 6.63592L1 11.349"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>All Categories</span>
          </button>
        </li>
        {categories.map((category, index) => (
          <li key={index} className="my-1.5">
            <button
              onClick={() => onCategorySelect(category)}
              className={`flex items-center gap-3 transition-all duration-300 text-paragraph hover:text-purple w-full text-left ${
                selectedCategory === category ? 'text-purple' : ''
              }`}
            >
              <svg
                width="6"
                height="13"
                viewBox="0 0 6 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.92285L4.59655 6.63592L1 11.349"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{category}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
});

CategoryList.displayName = 'CategoryList';

export default CategoryList;
